module.exports = __webpack_public_path__ + "static/media/Restrictions_on_gatherings_timeline.220ce30f.svg";